<template>
  <div class="NewsDetailView mx-auto d-flex justify-center scroll-container">
    <!-- PDF dialog fullscreen-->
    <v-dialog v-model="pdfDialog" rounded="false" fullscreen hide-overlay>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="navigateDetails(item)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ attachement ? attachement.title : '' }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div v-if="documentUrl !== null" style="height: calc(100vh - 64px) !important">
          <pdf-js
            :url="documentUrl"
            :page="$route.query.page"
            :search="$route.query.search"
            :download-file-name="downloadFileName"
            :hide-pdf-open-icon="hidePdfOpenIcon"
          ></pdf-js>
        </div>
      </v-card>
    </v-dialog>

    <!-- News Card -->
    <div
      v-if="item && dataLoaded"
      class="NewsDetailCard full-width mt-lg-2 mt-0 mb-0 mb-lg-2 mx-0"
      style="transition: all 2s; max-width: 1296px; height: fit-content !important"
    >
      <v-img v-if="teaserExists" :src="teaserUrl" class="img-border-bottom" cover height="50vh"></v-img>
      <div class="mx-sm-0 ma-3" style="margin-bottom: 40vh; height: 100%">
        <div class="px-4 pt-2">
          <subtitle-1 :newsItem="item" :showAttachementCount="false"></subtitle-1>
          <subtitle-2
            class="mt-2"
            :item="item"
            :showAttachementCount="false"
            :displayViewCounter="displayViewCounter"
            :displayPublicationTime="displayPublicationTime"
          ></subtitle-2>
        </div>
        <v-card-title class="pt-0 news-detail-title">{{ item ? item.title : '' }}</v-card-title>
        <div class="px-xs-0 pa-4 text-content" v-html="itemContent"></div>

        <!-- List of pdf's -->
        <div v-for="pdf in sortedPdfs" :key="pdf.id" class="mt-3 px-1">
          <v-btn text rounded @click="navigateAttachement(pdf, 'details')">
            <v-icon left>mdi-file-document-outline</v-icon>
            {{ pdf.title }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import config from '@/common/config';
import PdfJs from '@/components/pdf/PdfJs';
import { mapState } from 'vuex';
import Subtitle1 from '../../components/Subtitle1.vue';
import Subtitle2 from '../../components/Subtitle2.vue';
import readService from '@/services/readService';
import index from './index';

export default {
  name: 'NewsItem',
  mixins: [common, configMixin, dateTimeMixin],
  components: {
    PdfJs,
    Subtitle1,
    Subtitle2,
  },
  created() {
    this.markAsRead();
  },

  data() {
    return {
      dialogTitle: '',
      file: null,
    };
  },
  computed: {
    ...mapState('news', ['news', 'newsById', 'mediasById', 'dataLoaded']),
    item() {
      if (this.dataLoaded) {
        return this.newsById[this.$route.params.itemId];
      }
      return null;
    },
    sortedPdfs() {
      return this.item && this.item._pdfs ? this.item._pdfs.slice().sort((a, b) => a.sort - b.sort) : [];
    },
    isUnread() {
      return readService.isUnread(this.item);
    },
    attachementId() {
      return this.$route.params.attachementId;
    },
    attachement() {
      if (this.attachementId) {
        let attachement = this.mediasById[this.attachementId];
        return attachement;
      }
      return null;
    },
    downloadFileName() {
      return this.attachement ? this.attachement.title : '';
    },
    documentUrl() {
      return this.attachement ? this.fileUrl(this.attachement) : null;
    },
    teaserExists() {
      return this.item && this.item._teasers && this.item._teasers.length > 0;
    },
    pdfDialog() {
      console.debug('pdfDialog route.name', this.$route.name);
      return this.attachement !== null;
    },
    teaserUrl() {
      let teaser = this.item._teasers && this.item._teasers.length > 0 ? this.item._teasers[0] : null;
      return teaser ? `${config.apiUrl}/medias/news/${teaser.filename}/${teaser.checksum}` : '';
    },
    hidePdfOpenIcon() {
      let moduleConfig = this.getModuleConfig(index.moduleType, this.item.instance);
      if (moduleConfig) {
        return moduleConfig.hidePdfOpenIcon !== undefined ? moduleConfig.hidePdfOpenIcon : false;
      }
      return false;
    },
    // Important note: Links (internal öV-Pad links and external links) get handled in src/interceptors.js#clickInterceptor
    //                 internal links need to be converted from öV-Pad links to nxg links and navigation has to be performed using vue router to avoid page reloads.
    //                 This is the reason for the most simple usage of the unparsed item content here.
    itemContent() {
      return this.item.content;
    },
    displayViewCounter() {
      let moduleConfig = this.getModuleConfig(index.moduleType, this.item.instance);
      if (moduleConfig) {
        return moduleConfig.displayViewCounter !== undefined ? moduleConfig.displayViewCounter : true;
      }
      return true;
    },
    displayPublicationTime() {
      let moduleConfig = this.getModuleConfig(index.moduleType, this.item.instance);
      if (moduleConfig) {
        return moduleConfig.displayPublicationTime !== undefined ? moduleConfig.displayPublicationTime : true;
      }
      return true;
    },
  },
  methods: {
    markAsRead() {
      if (this.item) {
        let type = this.$t(`type.${this.item._moduleId}`); //e.g. type.video or type.news
        let state = this.$t(`seen.${this.item._moduleId}`);
        let actionName = this.$t('action.marked');
        let sendboxTitle = this.item.title;
        let snackbarText = this.$t('markAsMsg', { type, title: this.item.title, state, actionName });

        this.$store.dispatch(
          `sendbox/markAsRead2`,
          {
            item: this.item,
            sendboxTitle,
            snackbarText,
            immediate: true,
          },
          { root: true }
        );

        // this.$store.dispatch(`sendbox/markAsRead`, { item: this.item });
      }
    },
    fileUrl(file) {
      return `${config.apiUrl}/medias/news/${file.filename}/${file.checksum}`;
    },
    displayDocument(file) {
      this.dialogTitle = file.title;
    },
    navigateDetails(item) {
      const { instance } = this.$route.params;
      this.$router.push(`/news/${instance}/${item.id}`);
    },
    navigateAttachement(attachement) {
      const { instance, itemId } = this.$route.params;
      this.$router.push(`/news/${instance}/${itemId}/${attachement.id}`);
    },
  },
  watch: {
    item(newValue, oldValue) {
      if (newValue) {
        console.debug('item changed');
        this.markAsRead();
      }
    },
  },
};
</script>
<style scoped>
.NewsDetailView {
  max-width: 1904px;
}
.NewsDetailCard {
  transition: all 2s;
  border-radius: 10px;
  overflow: hidden;
}

.theme--light .NewsDetailCard {
  background: white;
  border: 1px solid #e0e0e0;
}

.theme--dark .NewsDetailCard {
  background: #202020;
  border: 1px solid #1a1a1a;
}
.theme--light .img-border-bottom {
  filter: drop-shadow(2px 4px 6px #e0e0e0);
}

.theme--dark .img-border-bottom {
  filter: drop-shadow(2px 4px 6px #000);
}

.news-detail-title {
  font-size: 32px !important;
  font-weight: bold;
  line-height: 1.3;
}

@media (max-width: 600px) {
  .news-detail-title {
    font-size: 24px !important;
  }
}
</style>
